export default __webpack_public_path__ + "static/media/login-background.3c524ec9.jpg";